<script lang="ts">
  import AccountAppRedirect from '@dabble/components/AccountAppRedirect.svelte';
  import { profileUrl } from '@dabble/data/account-urls';
  import Route from '@dabble/toolkit/Route.svelte';
  import Auth from './Auth.svelte';
  import Preferences from './Preferences.svelte';
</script>

<Route path="/auth/:screen" component={Auth} />
<Route path="/account/preferences" component={Preferences} />
<Route path="/account/profile"><AccountAppRedirect to={profileUrl} /></Route>
